var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable, override } from 'mobx';
import { toNumber } from '../../../utils/helper/lodash_replacements';
import { QuestionScore } from '../../../classes/question/modules/QuestionScore';
export class AssociateScore extends QuestionScore {
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get question() {
        return this.parent;
    }
    get maxPoints() {
        return this.question.associateStore.askNum;
    }
    get reachedPoints() {
        let points = 0;
        // Formel: Anzahl an korrekt geklickten Optionen * maxPoints
        this.question.associationsToAsk
            .filter(a => a.isAssociationComplete && a.isCorrectlyAssociated)
            .forEach(association => {
            points += Math.max(0, 1 - association.numberOfFailedAttempts * (1 / this.question.options.length - 1));
        });
        return points;
    }
    get progressiveReachablePoints() {
        let points = 0;
        // Formel: Anzahl an korrekt geklickten Optionen * maxPoints
        this.question.associationsToAsk
            .filter(a => a.isAssociationComplete)
            .forEach(association => {
            points += Math.max(0, 1 - association.numberOfFailedAttempts * (1 / this.question.options.length - 1));
        });
        return points;
    }
    /*
    Associate: o;n;c&o;n;c&o;n;c&...
  o = associate id
  n = answer number
  c = target number
  (correct, if associate numer == target number)
     */
    get legacyEvalText() {
        return `${this.question.associationsToAsk
            .map(a => {
            return `${a.associateLegacyId};${a.associatedOptionNumber};${a.targetOptionNumber}`;
        })
            .join('&')}&`;
    }
    set legacyEvalText(t) {
        const pieces = t.slice(0, -1).split('&');
        for (const step of pieces) {
            const [associateId, associatedNumber, targetNumber] = step.split(';');
            const association = this.question.associateItems.getAssociationByLegacyId(toNumber(associateId));
            if (association) {
                //  && association.targetOptionNumber === toNumber(targetNumber)
                association.associatedOptionNumber = toNumber(associatedNumber);
            }
        }
    }
    get shouldSetCompletedTimestamp() {
        if (!this.question.answer)
            return false;
        if (this.question.remainingAssociations.length === 0)
            return true;
        return false;
    }
}
__decorate([
    override
], AssociateScore.prototype, "maxPoints", null);
__decorate([
    override
], AssociateScore.prototype, "reachedPoints", null);
__decorate([
    override
], AssociateScore.prototype, "progressiveReachablePoints", null);
__decorate([
    override
], AssociateScore.prototype, "shouldSetCompletedTimestamp", null);
